module.exports = __webpack_public_path__ + "media/icons/smartsearch/colors/brown-80faa00bae6fd56e115ba47f183327ac.png";